/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
var ExpandAllButton = (function() {
  let replace = undefined;
  let showElements = undefined;
  let triggerEvents = undefined;
  ExpandAllButton = class ExpandAllButton {
    static initClass() {
  
      replace = function(el) {
        const target = $(el.data('target'));
        return el.replaceWith(CollapseAllButton.create({target}));
      };
  
      showElements = function(el) {
        const target = $(el.data('target'));
        return target.find('[data-toggle="collapse"]:contains("Expand")').click();
      };
  
      triggerEvents = el => $(document).trigger({
        type: 'collapse:expanded',
        element: $(el.data('target'))
      });
    }
    constructor() {
      $(document).on('click', '[data-expand-all]', function(e) {
        const el = $(e.currentTarget);
        showElements(el);
        replace(el);
        return triggerEvents(el);
      });
    }

    static create(options) {
      /*
      Required attributes:
        * data-target
      */
      return $('<button>')
        .attr('data-expand-all', true)
        .text('Expand All')
        .addClass('btn btn-sm btn-success')
        .data('target', options.target);
    }
  };
  ExpandAllButton.initClass();
  return ExpandAllButton;
})();

global.ExpandAllButton = ExpandAllButton;

export default ExpandAllButton;